import config from '../config';

const { webUIUrl } = config;

export const getAppUrl = (path) => `${webUIUrl}${path}`;
